var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConflictFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18.0055,
    height: 19.0018,
    viewBox: "0 0 18.0055 19.0018",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0 0.75C0 0.335786 0.335786 0 0.75 0H17.2541C17.8722 0 18.225 0.705647 17.8541 1.20006L13.6898 6.75122L17.8541 12.3024C18.225 12.7968 17.8722 13.5024 17.2541 13.5024L1.5 13.502V18.2518C1.5 18.6315 1.21785 18.9453 0.851771 18.995L0.75 19.0018C0.370304 19.0018 0.0565091 18.7197 0.00684667 18.3536L0 18.2518V0.75ZM15.7539 1.5H1.5V12.0024H15.7539L12.1522 7.20129C11.9522 6.93459 11.9522 6.56785 12.1522 6.30116L15.7539 1.5Z",
    fill: "#8B4409"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConflictFlag);
export default __webpack_public_path__ + "static/media/conflict-flag.a5f2fec45ef311b84b81a0e6d7978d1d.svg";
export { ForwardRef as ReactComponent };